var map = {
	"./acaademForm.json": 90733,
	"./academ.json": 82156,
	"./accounting.json": 90859,
	"./admin.json": 68273,
	"./adminPage.json": 90046,
	"./archive.json": 83727,
	"./assignments.json": 26789,
	"./auth.json": 31974,
	"./auto.json": 47833,
	"./calendar.json": 77201,
	"./career.json": 60277,
	"./chat.json": 95852,
	"./chatForm.json": 44307,
	"./collective.json": 78053,
	"./common.json": 83147,
	"./components.json": 2727,
	"./dashboard.json": 58205,
	"./deanDash.json": 880,
	"./diploma.json": 9404,
	"./distance.json": 94832,
	"./dorm.json": 48142,
	"./dpo.json": 77750,
	"./employees.json": 71097,
	"./europass.json": 67122,
	"./foreign.json": 52,
	"./forms.json": 3544,
	"./gradebook.json": 88015,
	"./groups.json": 97982,
	"./help.json": 77612,
	"./helpPage.json": 97485,
	"./helpers.json": 11059,
	"./hooks.json": 85713,
	"./integrations.json": 80554,
	"./journal.json": 82064,
	"./kanban.json": 17623,
	"./lang.json": 19305,
	"./library.json": 49266,
	"./loginPage.json": 69909,
	"./main.json": 13644,
	"./menu.json": 81507,
	"./menuDrawer.json": 25905,
	"./military.json": 26587,
	"./noMatch.json": 2805,
	"./notes.json": 6850,
	"./notification.json": 2601,
	"./orderForm.json": 44685,
	"./orders.json": 57683,
	"./ordersPage.json": 15225,
	"./pages.json": 7881,
	"./plagiarism.json": 63307,
	"./postgrad.json": 83646,
	"./practice.json": 65108,
	"./profile.json": 60828,
	"./profilePage.json": 92736,
	"./qr.json": 65571,
	"./quiz.json": 98414,
	"./quizForm.json": 99780,
	"./report_card.json": 1606,
	"./reports.json": 94896,
	"./schedule.json": 6321,
	"./science.json": 91834,
	"./sessions.json": 37816,
	"./statements.json": 19646,
	"./statementsPage.json": 48409,
	"./statistic.json": 94794,
	"./statisticPage.json": 5131,
	"./structure.json": 76915,
	"./structureForm.json": 75908,
	"./studentDash.json": 59453,
	"./studentLife.json": 5659,
	"./students.json": 14681,
	"./subjectPage.json": 6822,
	"./support.json": 92808,
	"./survey.json": 75201,
	"./surveyForm.json": 15184,
	"./surveys.json": 90974,
	"./syllabus.json": 72793,
	"./taskForm.json": 57425,
	"./taskInfo.json": 4350,
	"./taskItem.json": 76620,
	"./tasks.json": 81985,
	"./tasksPage.json": 17126,
	"./teacherDash.json": 6482,
	"./test.json": 55571,
	"./testForm.json": 60090,
	"./tests.json": 2855,
	"./ui.json": 12945,
	"./user.json": 51375,
	"./utils.json": 77378,
	"./weather.json": 45870,
	"locales/en/acaademForm.json": 90733,
	"locales/en/academ.json": 82156,
	"locales/en/accounting.json": 90859,
	"locales/en/admin.json": 68273,
	"locales/en/adminPage.json": 90046,
	"locales/en/archive.json": 83727,
	"locales/en/assignments.json": 26789,
	"locales/en/auth.json": 31974,
	"locales/en/auto.json": 47833,
	"locales/en/calendar.json": 77201,
	"locales/en/career.json": 60277,
	"locales/en/chat.json": 95852,
	"locales/en/chatForm.json": 44307,
	"locales/en/collective.json": 78053,
	"locales/en/common.json": 83147,
	"locales/en/components.json": 2727,
	"locales/en/dashboard.json": 58205,
	"locales/en/deanDash.json": 880,
	"locales/en/diploma.json": 9404,
	"locales/en/distance.json": 94832,
	"locales/en/dorm.json": 48142,
	"locales/en/dpo.json": 77750,
	"locales/en/employees.json": 71097,
	"locales/en/europass.json": 67122,
	"locales/en/foreign.json": 52,
	"locales/en/forms.json": 3544,
	"locales/en/gradebook.json": 88015,
	"locales/en/groups.json": 97982,
	"locales/en/help.json": 77612,
	"locales/en/helpPage.json": 97485,
	"locales/en/helpers.json": 11059,
	"locales/en/hooks.json": 85713,
	"locales/en/integrations.json": 80554,
	"locales/en/journal.json": 82064,
	"locales/en/kanban.json": 17623,
	"locales/en/lang.json": 19305,
	"locales/en/library.json": 49266,
	"locales/en/loginPage.json": 69909,
	"locales/en/main.json": 13644,
	"locales/en/menu.json": 81507,
	"locales/en/menuDrawer.json": 25905,
	"locales/en/military.json": 26587,
	"locales/en/noMatch.json": 2805,
	"locales/en/notes.json": 6850,
	"locales/en/notification.json": 2601,
	"locales/en/orderForm.json": 44685,
	"locales/en/orders.json": 57683,
	"locales/en/ordersPage.json": 15225,
	"locales/en/pages.json": 7881,
	"locales/en/plagiarism.json": 63307,
	"locales/en/postgrad.json": 83646,
	"locales/en/practice.json": 65108,
	"locales/en/profile.json": 60828,
	"locales/en/profilePage.json": 92736,
	"locales/en/qr.json": 65571,
	"locales/en/quiz.json": 98414,
	"locales/en/quizForm.json": 99780,
	"locales/en/report_card.json": 1606,
	"locales/en/reports.json": 94896,
	"locales/en/schedule.json": 6321,
	"locales/en/science.json": 91834,
	"locales/en/sessions.json": 37816,
	"locales/en/statements.json": 19646,
	"locales/en/statementsPage.json": 48409,
	"locales/en/statistic.json": 94794,
	"locales/en/statisticPage.json": 5131,
	"locales/en/structure.json": 76915,
	"locales/en/structureForm.json": 75908,
	"locales/en/studentDash.json": 59453,
	"locales/en/studentLife.json": 5659,
	"locales/en/students.json": 14681,
	"locales/en/subjectPage.json": 6822,
	"locales/en/support.json": 92808,
	"locales/en/survey.json": 75201,
	"locales/en/surveyForm.json": 15184,
	"locales/en/surveys.json": 90974,
	"locales/en/syllabus.json": 72793,
	"locales/en/taskForm.json": 57425,
	"locales/en/taskInfo.json": 4350,
	"locales/en/taskItem.json": 76620,
	"locales/en/tasks.json": 81985,
	"locales/en/tasksPage.json": 17126,
	"locales/en/teacherDash.json": 6482,
	"locales/en/test.json": 55571,
	"locales/en/testForm.json": 60090,
	"locales/en/tests.json": 2855,
	"locales/en/ui.json": 12945,
	"locales/en/user.json": 51375,
	"locales/en/utils.json": 77378,
	"locales/en/weather.json": 45870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18963;